import { ComponentFactoryResolver, ComponentRef, Injectable, TemplateRef, Type } from '@angular/core';

import {
  ElComponentPortal,
  ElComponentType,
  ElOverlay,
  ElOverlayConfig,
  ElOverlayRef,
  ElScrollStrategyOptions,
} from './mapping';
import { ElLayoutDirectionService } from '../../../services/direction.service';


export type ElOverlayContent = Type<any> | TemplateRef<any> | string;

export function patch<T>(container: ComponentRef<T>, containerContext: Object): ComponentRef<T> {
  Object.assign(container.instance, containerContext);
  container.changeDetectorRef.detectChanges();
  return container;
}

export function createContainer<T>(
  ref: ElOverlayRef,
  container: ElComponentType<T>,
  context: Object,
  componentFactoryResolver?: ComponentFactoryResolver,
  ): ComponentRef<T> {
  const containerRef = ref.attach(new ElComponentPortal(container, null, null, componentFactoryResolver));
  patch(containerRef, context);
  return containerRef;
}

@Injectable()
export class ElOverlayService {
  constructor(protected overlay: ElOverlay, protected layoutDirection: ElLayoutDirectionService) {
  }

  get scrollStrategies(): ElScrollStrategyOptions {
    return this.overlay.scrollStrategies;
  }

  create(config?: ElOverlayConfig): ElOverlayRef {
    const overlayRef = this.overlay.create(config);
    this.layoutDirection.onDirectionChange()
      .subscribe(dir => overlayRef.setDirection(dir));
    return overlayRef;
  }
}
